$(document).ready(function () {

  function closeFilterModal() {
    $('.blog-archive-filter').find('.filter-container').css('max-height', 0);
    $('.blog-archive-filter').removeClass('filter-opened');
    $('body').removeClass('modal-open');
  }

  function openFilterModal() {
    $('.blog-archive-filter').addClass('filter-opened');
    $('body').addClass('modal-open');

    var filterControlHeight = $('.blog-archive-filter').offset().top - $(window).scrollTop() + $('.blog-archive-filter').height();

    $('.blog-archive-filter .filter-container').css('max-height', 'calc(100vh - ' +  filterControlHeight + "px)");

    // Set .filter-container max-height after animation for smoother animation on collapse
    setTimeout(function () {
      var $filterContainer = $('.blog-archive-filter .filter-container');
      if ($filterContainer.css('max-height') > $filterContainer.height()) $filterContainer.css('max-height', $filterContainer.height() + "px");
    }, 500);
  }

  function setFilterValues($form) {
    var checkVals = [];
    $form.find(":checkbox").each(function () {
      if (this.checked) {
        checkVals.push($(this).val());
      }
    });
    $form.find("input[name='categories']").val(checkVals.join());
  }

  if ($('.blog-archive-filter').length) {

    // Toggle modal on .filter-toggle click
    $(document).on("click", ".blog-archive-filter .filter-toggle", function () {
      if ($('.blog-archive-filter').hasClass('filter-opened')) {
        closeFilterModal();
      } else {
        openFilterModal();
      }
    });

    // Close modal on apply click
    $('.apply-filters-button').click(function () {
      var $form = $(this).closest("form");

      setFilterValues($form);
      $form.submit();
    });

    // Close modal on click outside
    $(document).on('click', function (e) {
      if (!$(e.target).closest('.blog-archive-filter').length) closeFilterModal();
    });

    // Close modal on resize
    $(window).on('resize', function () {
      closeFilterModal();
    });

    // Natural vs Fixed Positioning (If Scrolled Past)
    var $blogFilter = $(".blog-archive-filter");
    var blogFilterWaypoint = new Waypoint.Sticky({
      element: $blogFilter[0],
      stuckClass: 'fixed',
      offset: function () {
        return $(".navigation").height();
      }
    });
  }
});
